<template>
  <v-card class="grey lighten-3 mt-2" width="" min-height="60" style="border: solid 1px">
    <v-row class="ml-10 mr-3">
      <v-col cols="10" class="mr-xs-15 mr-sm-9 mr-md-16 mr-lg-16 pb-0" style="padding-bottom: 0px">
        <v-spacer></v-spacer>
      </v-col>
      <v-col cols="1" class="mb-0 pb-0">
        <v-dialog-pin :dialogPin="schema.dialogAccountPin" class="mb-0 pt-0" />
      </v-col>
    </v-row>
    <v-form class="d-flex justify-center mb-2">
      <v-form-base
        v-if="Object.keys(schema.schemaIdent || {}).length && Object.keys(modelForm || {}).length"
        :schema="schema.schemaIdent"
        :model="modelForm"
        @input="handleEvents"
        class="d-flex flex-md-nowrap"
      />
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VFormBase from 'vuetify-form-base';
import VDialogPin from '@/components/base/VDialogPin.vue';

export default {
  name: 'VBannerLineDataPatient',
  components: {
    VFormBase,
    VDialogPin,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
    this.loadModelForm();
  },
  computed: {
    ...mapGetters('anamLineData', ['schema', 'modelForm']),
  },
  methods: {
    ...mapActions('anamLineData', ['loadSchema', 'loadModelForm']),

    handleEvents() {},
  },
};
</script>
